
import Hammer from 'hammerjs';

let curScale = false, curMove = false, ifOnClick = false, lastX = 0, lastY = 0, currentX = 0, currentY = 0, xChange = 0, yChange = 0, zoomStartScale, selectedItem;
class markPreview {
    constructor() {
        this.minimap = null;
        this.design = null;
        this.containerWidth = 1320
        this.viewWidth = window.innerWidth;//可视区域
        this.viewHeight = this.containerWidth / 2;//可视区域
        this.isPc = window.innerWidth > 992;
        this.strokeColor = "#E34F51";//多的
        this.isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }

    //销毁
    dispose() {
        if (this.design != null) {
            this.design.clear();
            this.design.dispose();
            this.design = null;
            this.minimap.clear();
            this.minimap.dispose();
            this.minimap = null;
        }
    }

    //初始化
    render(clickCallback, strokeColor) {
        if (strokeColor) {
            this.strokeColor = strokeColor;//多的
        }
        this.isPc = window.innerWidth > 992;
        this.dispose()

        this.minimap = new fabric.Canvas('markLayoutPreviewMiniMap', { containerClass: 'resourceMarkMiniMap1', selection: false });
        this.design = new fabric.Canvas('markLayoutPreviewCanvas', {
            width: this.containerWidth,
            height: this.containerWidth / 2,
            selection: false,
            devicePixelRatio: true,
            allowTouchScrolling: true,
            containerClass: 'resourceMarkCanvasContainer'
        });

        let parentNode = null;
        if (document.getElementById("markLayoutPreviewCanvas")) {
            parentNode = document.getElementById("markLayoutPreviewCanvas").parentNode;
        }
        if (parentNode) {
            this.viewWidth = Math.min(parentNode.offsetWidth, this.containerWidth, window.innerWidth);
            this.viewHeight = Math.min(parentNode.offsetHeight, this.containerWidth / 2, window.innerHeight)
        }
        let that = this, design = that.design;
        design.perPixelTargetFind = true;
        design.targetFindTolerance = 4;
        if (!that.isTouch) {
            design.on('mouse:wheel', function (opt) {
                curScale = true;//当前在缩放
                var delta = opt.e.deltaY;
                var zoom = design.getZoom();
                zoom *= 0.999 ** delta;
                if (zoom > 20) zoom = 20;
                if (zoom < 0.01) zoom = 0.01;
                design.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);

                var vpt = this.viewportTransform;
                let wz = design.getWidth() * (1 - zoom) - (design.getWidth() - that.viewWidth), hz = design.getHeight() * (1 - zoom) - (design.getHeight() - that.viewHeight);
                if (zoom < that.viewWidth / design.getWidth()) {
                    vpt[4] = wz / 2;
                } else {
                    if (vpt[4] >= 0) {
                        vpt[4] = 0;
                    } else if (vpt[4] < wz) {
                        vpt[4] = wz;
                    }
                }
                if (zoom < that.viewHeight / design.getHeight()) {
                    vpt[5] = hz / 2;
                } else {
                    if (vpt[5] >= 0) {
                        vpt[5] = 0;
                    } else if (vpt[5] < hz) {
                        vpt[5] = hz;
                    }
                }

                that.updateMiniMapVP();
                opt.e.preventDefault();
                opt.e.stopPropagation();
            })
            design.on('mouse:down', function (opt) {
                var evt = opt.e;
                this.isDragging = true;
                this.lastPosX = evt.clientX;
                this.lastPosY = evt.clientY;
                that.defaultClick();
                that.findTarget(evt);

            });
            design.on('mouse:move', function (opt) {
                if (this.isDragging) {
                    var e = opt.e;
                    var vpt = this.viewportTransform;

                    var zoom = design.getZoom();
                    let wz = design.getWidth() * (1 - zoom) - (design.getWidth() - that.viewWidth), hz = design.getHeight() * (1 - zoom) - (design.getHeight() - that.viewHeight);
                    if (zoom < that.viewWidth / design.getWidth()) {
                        vpt[4] = wz / 2;
                    } else {
                        vpt[4] += e.clientX - this.lastPosX;
                        if (vpt[4] >= 0) {
                            vpt[4] = 0;
                        } else if (vpt[4] < wz) {
                            vpt[4] = wz;
                        }
                    }
                    if (zoom < that.viewHeight / design.getHeight()) {
                        vpt[5] = hz / 2;
                    } else {
                        vpt[5] += e.clientY - this.lastPosY;
                        if (vpt[5] >= 0) {
                            vpt[5] = 0;
                        } else if (vpt[5] < hz) {
                            vpt[5] = hz;
                        }
                    }

                    design.requestRenderAll();
                    that.updateMiniMapVP();
                    this.lastPosX = e.clientX;
                    this.lastPosY = e.clientY;
                    curMove = true;//当前在移动
                }
            })
            design.on('mouse:up', function (opt) {
                design.setViewportTransform(this.viewportTransform);
                this.isDragging = false;
                that.touchSelected(clickCallback);
            });
        } else {
            var hammer = new Hammer(design.upperCanvasEl);
            hammer.get('pinch').set({ enable: true });
            hammer.get('pan').set({ direction: Hammer.DIRECTION_ALL });
            hammer.on('pinchstart', function (event) {
                curScale = true;
                zoomStartScale = design.getZoom();
            });

            hammer.on('pinchmove', function (event) {
                let zoom = zoomStartScale * event.scale;
                if (zoom > 10) zoom = 10;
                if (zoom < 0.09) zoom = 0.09;

                let canvasRect = design.upperCanvasEl.getBoundingClientRect();
                let touchX = event.center.x - canvasRect.left;
                let touchY = event.center.y - canvasRect.top;
                design.zoomToPoint(new fabric.Point(touchX, touchY), zoom);

                var vpt = design.viewportTransform;
                //因为移动端是竖屏 必须要减去当前的宽才可以看到右侧隐藏的区域
                let wz = design.getWidth() * (1 - zoom) - (design.getWidth() - that.viewWidth),
                    hz = design.getHeight() * (1 - zoom) - (design.getHeight() - that.viewHeight);
                if (zoom < that.viewWidth / design.getWidth()) {//因为移动端竖屏的关系 必须在他们的比例下才执行左侧固定
                    vpt[4] = wz / 2;
                } else {
                    if (vpt[4] >= 0) {
                        vpt[4] = 0;
                    } else if (vpt[4] < wz) {
                        vpt[4] = wz;
                    }
                }
                if (zoom < that.viewHeight / design.getHeight()) {
                    vpt[5] = hz / 2;
                } else {
                    if (vpt[5] >= 0) {
                        vpt[5] = 0;
                    } else if (vpt[5] < hz) {
                        vpt[5] = hz;
                    }
                }
                that.updateMiniMapVP();
            });


            hammer.on('panstart', function (event) {
                lastX = event.deltaX;
                lastY = event.deltaY;
            });

            hammer.on('panmove', function (event) {
                currentX = event.deltaX;
                currentY = event.deltaY;
                xChange = currentX - lastX;
                yChange = currentY - lastY;
                if (xChange * -1 >= 0.4 || yChange * -1 >= 0.4) {
                    curMove = true;//当前在移动
                }
                var vpt = design.viewportTransform;
                var zoom = design.getZoom();
                let wz = design.getWidth() * (1 - zoom) - (design.getWidth() - that.viewWidth),
                    hz = design.getHeight() * (1 - zoom) - (design.getHeight() - that.viewHeight);
                if (zoom < that.viewWidth / design.getWidth()) {
                    vpt[4] = wz / 2;
                } else {
                    vpt[4] += xChange;
                    if (vpt[4] >= 0) {
                        vpt[4] = 0;
                    } else if (vpt[4] < wz) {
                        vpt[4] = wz;
                    }
                }
                if (zoom < that.viewHeight / design.getHeight()) {
                    vpt[5] = hz / 2;
                } else {
                    vpt[5] += yChange;
                    if (vpt[5] >= 0) {
                        vpt[5] = 0;
                    } else if (vpt[5] < hz) {
                        vpt[5] = hz;
                    }
                }
                design.requestRenderAll();
                that.updateMiniMapVP();
                lastX = event.deltaX;
                lastY = event.deltaY;
            });

            //单击
            hammer.on('tap', function (event) {
                that.defaultClick();
                that.findTarget(event.srcEvent);
                that.touchSelected(clickCallback);
            });
        }
    }


    findTarget(e) {
        let that = this, design = that.design;
        let objects = design.getObjects();
        if (objects && objects.length > 0) {
            let pointer = design.getPointer(e);
            for (let i = 0; i < objects.length; i++) {
                let object = objects[i];
                if (object.markData && object.markData.markId && object.containsPoint(pointer, null, true)) {
                    let pointers = design.getPointer(e, true);
                    if (!design.isTargetTransparent(object, pointers.x, pointers.y)) {
                        selectedItem = object;
                        break;
                    }
                }
            }
        }
    }
    touchSelected(callback) {
        let that = this;
        if (!ifOnClick) {
            ifOnClick = true;
            if (selectedItem && that.isClick()) {
                console.info(JSON.stringify(selectedItem.markData));
                callback && callback(selectedItem.markData);
            }
            selectedItem = null;
            setTimeout(() => {
                ifOnClick = false;
            }, 50)
        }
    }

    defaultClick() {
        curScale = false;
        curMove = false;
    }
    isClick() {
        return !curScale && !curMove;
    }

    createCanvasEl() {
        let that = this, design = that.design, minimap = that.minimap;
        var designSize = { width: design.getWidth(), height: design.getHeight() };
        var originalVPT = design.viewportTransform;
        var designRatio = fabric.util.findScaleToFit(designSize, design);
        var minimapRatio = fabric.util.findScaleToFit(design, minimap);
        var scaling = minimap.getRetinaScaling();
        var finalWidth = designSize.width * designRatio;
        var finalHeight = designSize.height * designRatio;
        design.viewportTransform = [
            designRatio, 0, 0, designRatio,
            (design.getWidth() - finalWidth) / 2,
            (design.getHeight() - finalHeight) / 2
        ];
        var ca = design.toCanvasElement(minimapRatio * scaling);
        design.viewportTransform = originalVPT;
        return ca;
    }
    updateMiniMap() {
        let that = this, minimap = that.minimap;
        minimap.backgroundImage._element = that.createCanvasEl();
        minimap.requestRenderAll();
    }
    updateMiniMapVP() {
        let that = this, design = that.design, minimap = that.minimap;
        var designSize = { width: design.getWidth(), height: design.getHeight()  };
        var rect = minimap.getObjects()[0];
        var designRatio = fabric.util.findScaleToFit(designSize, design);
        var totalRatio = fabric.util.findScaleToFit(designSize, minimap);
        var finalRatio = designRatio / design.getZoom();
        rect.scaleX = finalRatio;
        rect.scaleY = finalRatio;
        rect.top = minimap.backgroundImage.top - design.viewportTransform[5] * totalRatio / design.getZoom();
        rect.left = minimap.backgroundImage.left - design.viewportTransform[4] * totalRatio / design.getZoom();
        minimap.requestRenderAll();
    }
    initMinimap() {
        let that = this, design = that.design, minimap = that.minimap, isPc = that.isPc;
        var backgroundImage = new fabric.Image(that.createCanvasEl());
        backgroundImage.scaleX = 1 / design.getRetinaScaling();
        backgroundImage.scaleY = 1 / design.getRetinaScaling();
        minimap.centerObject(backgroundImage);
        minimap.backgroundColor = 'white';
        minimap.backgroundImage = backgroundImage;
        minimap.requestRenderAll();
        var minimapView = new fabric.Rect({
            top: backgroundImage.top,
            left: backgroundImage.left,
            width: isPc ? backgroundImage.width / design.getRetinaScaling() : (backgroundImage.height / 2 / design.getRetinaScaling() + 5),//加5我也不知道是什么原因
            height: backgroundImage.height / design.getRetinaScaling(),
            fill: 'rgba(0, 0, 255, 0.3)',
            cornerSize: 6,
            transparentCorners: false,
            cornerColor: 'blue',
            strokeWidth: 0,
        });
        minimapView.controls = {
            br: fabric.Object.prototype.controls.br,
        };
        minimap.add(minimapView);
    }

    reRender(canvasData, successCallback) {
        let that = this, design = that.design, minimap = that.minimap
        design.clear();
        minimap.clear();
        setTimeout(function () {
            fabric.Object.prototype.selectable = false;

            if (!canvasData) {
                canvasData = "{}";
            }
            if (typeof canvasData === 'string') {
                canvasData = JSON.parse(canvasData);
            }

            if (that.isEmptyObject(canvasData)) {
                return;
            }

            if (canvasData.objects) {
                for (let i = 0; i < canvasData.objects.length; i++) {
                    let item = canvasData.objects[i];
                    if (item.markData && item.markData.markId) {
                        item.fill = "rgba(255, 255, 255, .1)";
                        if (item.stroke == that.strokeColor) {
                            item.stroke = "rgba(255, 255, 255, .1)";
                        }
                    }
                }
            }
            design.loadFromJSON(canvasData, function () {
                design.getObjects().forEach(function (obj) {
                    if (obj.type === 'group') {
                        obj.toActiveSelection();
                    } else if (obj.type == "rect" && obj.left == 0 && obj.top == 0) {
                        obj.set({ evented: false });
                    }
                })
                design.setOverlayImage(null, design.renderAll.bind(design));

                let zooms = that.viewWidth / that.containerWidth
                design.setZoom(zooms);
                design.viewportTransform = [zooms, 0, 0, zooms, 0, (design.getHeight() * (1 - zooms) - (design.getHeight() - that.viewHeight)) / 2];

                that.initMinimap();
                // 将视口变换设置为默认值
                design.renderAll(); // 重新渲染画布
                //大的Canvas重新渲染后，更新缩略图
                that.updateMiniMapVP();
                successCallback && successCallback(design.getObjects().filter((item) => { return item.markData }));
            });

        }, 50);
    }
   addExtraElement(room, sign) {
        let that = this
        const nameText = new fabric.Text(room.name, {
            top: 5,
            fontSize: 15,
            fontWeight: 'bold',
            fill: '#000',
            originX: 'center',
            originY: 'top',
        });
        const totalText = new fabric.Text(`总数：${room.seatTotal}`, {
            top: nameText.top + nameText.height + 4,
            fontSize: 12,
            fontWeight: 'bold',
            fill: '#000',
            originX: 'center',
            originY: 'top',
        });
        const freeText = new fabric.Text(`可用：${room.seatFree}`, {
            top: totalText.top + totalText.height + 4,
            fontSize: 12,
            fontWeight: 'bold',
            fill: '#000',
            originX: 'center',
            originY: 'top',
        });

        const componentWidth = Math.max(nameText.getScaledWidth() + 10, totalText.getScaledWidth() + 10, freeText.getScaledWidth() + 10);
        nameText.set({
            left: componentWidth / 2,
        });
        totalText.set({
            left: componentWidth / 2,
        });
        freeText.set({
            left: componentWidth / 2,
        });


        // 进度条容器背景
        const progressContainer = new fabric.Rect({
            left: 5,
            top: freeText.top + freeText.height + 4,
            width: componentWidth - 10, // 使用动态计算的宽度
            height: 10,
            fill: '#ff5a5a',
            rx: 6,
            ry: 6,
            originX: 'left'
        });

        // 可用进度
        const availableProgress = new fabric.Rect({
            left: 5,
            top: freeText.top + freeText.height + 4,
            width: (componentWidth - 10) * (room.seatFree / room.seatTotal),
            height: 10,
            fill: '#4cd964',
            rx: 6,
            ry: 6,
            originX: 'left',
        });

        const background = new fabric.Rect({
            left: 0,
            top: 0,
            width: componentWidth,
            height: progressContainer.top + progressContainer.height + 4,
            fill: 'white',
            opacity: 0.6, // 60%不透明度，可根据需要调整
            rx: 8,       // 圆角效果
            ry: 8,
            selectable: false
        });

        // 组合所有元素
        const groupElements = [
            background,
            nameText,
            totalText,
            freeText,
            progressContainer,
            availableProgress
        ];

        const group = new fabric.Group(groupElements, {
            left: sign.markData.left || sign.left,
            top: sign.markData.top || sign.top,
            angle: sign.markData.angle || 0,
            scaleX: sign.markData.scaleX || 1,
            scaleY: sign.markData.scaleY || 1,
            selectable: false
        });

        // 将组合添加到画布并渲染
        that.design && that.design.add(group);
        that.design && that.design.renderAll();
    }
    isEmptyObject(e) {
        var t;
        for (t in e)
            return !1;
        return !0;
    }
}

//对外暴露的接口
export default markPreview



// WEBPACK FOOTER //
// ./src/lib/markPreview.js